import { ListItemText, Menu, MenuItem, MenuProps } from "@mui/material";
import { memo, useCallback } from "react";
import { useAppSelector, useAppDispatch } from "stores";
import { appStateMutate } from "stores/modules/app.state/operations";
import { getAppState } from "stores/modules/app.state/selectors";
import { getUserMediumDirectories } from "stores/modules/entities.user.mediumDirectories/selectors";
import { changeDirSelectedMedia } from "stores/modules/entities.user.media/operations";

type MediumListOfficialPlaylistItemMenuProps = {
  open: boolean;
  anchorEl?: MenuProps["anchorEl"];
  onClose: () => void;
};

const MediumListSelectingMediaMoveMenu = ({
  open,
  anchorEl,
  onClose,
}: MediumListOfficialPlaylistItemMenuProps) => {
  const d = useAppDispatch();

  const selectedMediaIds = useAppSelector((state) => {
    return getAppState(state, "selectedMediaIds");
  });
  const tabs = useAppSelector((state) => getUserMediumDirectories(state));

  const moveSelectedMedia = useCallback(
    (dir: string) => {
      d(changeDirSelectedMedia(selectedMediaIds, dir));
      d(
        appStateMutate((state) => {
          state.selectingMedia = false;
          state.selectedMediaIds = [];
        })
      );
    },
    [d, selectedMediaIds]
  );

  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      onClose={onClose}
    >
      {tabs.map((tab) => (
        <MenuItem
          onClick={() => moveSelectedMedia(tab.id)}
          sx={{ minWidth: "220px" }}
        >
          <ListItemText>{tab.name}</ListItemText>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default memo(MediumListSelectingMediaMoveMenu);
